import React from 'react';
import { HiDownload, HiChevronDown } from 'react-icons/hi';
import PopoverMenu from './PopoverMenu';
import { formatFileSize } from '../utils/requestGroups';

// Download menu: a small teal button that opens a menu of the downloadable
// versions — Original first, then each MP4 rendition — each with its size
// and container (or asset count) on a second line.
// `options` = [{ label, type, sizeMb, ext, note? }] (getDownloadFormatOptions
// for one asset, getGroupZipOptions for a request); `onPick(option)`.
// `variant="zip"` renders the trigger as a "ZIP" button for the whole-request
// download; both variants share the same caption so the two menus look alike.
const HEADING = 'Choose a version';

export default function DownloadMenu({ options = [], onPick, label = 'Download', variant = 'icon' }) {
    if (!options.length) return null;

    const items = options.map((o, i) => {
        const size = formatFileSize(o.sizeMb);
        const meta = [size && (o.sizeApprox ? `over ${size}` : size), o.ext, o.note].filter(Boolean).join(' · ');
        return {
            key: `${i}-${o.type}`,
            onSelect: () => onPick(o),
            children: (
                <>
                    <span className="popover-menu__item-icon"><HiDownload size={16} /></span>
                    <span className="popover-menu__item-text">
                        <span className="popover-menu__item-name">{o.label}</span>
                        {meta && <span className="popover-menu__item-meta">{meta}</span>}
                    </span>
                </>
            ),
        };
    });

    return (
        <PopoverMenu heading={HEADING} items={items}
            renderTrigger={({ ref, open, toggle, onKeyDown }) => (
                <button ref={ref} type="button" className={`download-menu__btn${variant === 'zip' ? ' download-menu__btn--zip' : ''}`}
                    aria-haspopup="menu" aria-expanded={open} aria-label={label} title={label} onClick={toggle} onKeyDown={onKeyDown}>
                    <HiDownload size={14} />
                    {variant === 'zip' && <span className="download-menu__btn-text">ZIP</span>}
                    <HiChevronDown size={12} className="download-menu__caret" />
                </button>
            )} />
    );
}
